module.exports = __webpack_public_path__ + "static/edge-of-the-universe-4711e4715782b5852d799476fd91c196.jpg";